export const getStatusBadgeClass = (status: string): string => {
  const statusLower = status.toLowerCase();
  if (
    statusLower.includes("enviado") ||
    statusLower.includes("sent") ||
    statusLower === "enviado"
  ) {
    return "bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300";
  }
  if (
    statusLower.includes("aprovado") ||
    statusLower.includes("approved")
  ) {
    return "bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300";
  }
  if (
    statusLower.includes("recusado") ||
    statusLower.includes("rejected") ||
    statusLower.includes("rejeitado")
  ) {
    return "bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300";
  }
  if (statusLower.includes("criado") || statusLower.includes("created")) {
    return "bg-gray-100 dark:bg-neutral-700 text-gray-700 dark:text-neutral-300";
  }
  return "bg-gray-100 dark:bg-neutral-700 text-gray-700 dark:text-neutral-300";
};

export const getRecipientLabel = (recipient: string): string => {
  if (recipient === "CONSULTANT") {
    return "Consultor da concessionária";
  }
  if (recipient === "FACTORY") {
    return "Volks|total";
  }
  if (recipient === "MANAGER") {
    return "Gestor de frota";
  }
  return recipient;
};
